import { Controller } from "@hotwired/stimulus"

// Settings › Donations, the Donation row's panel (TMS-1888): "Your next gift of $X will be on
// <date>" follows the amount as it's typed. The server checks the amount again on save.
export default class extends Controller {
  static targets = ["amount", "preview"]

  sync() {
    if (!this.hasPreviewTarget) return

    const cleaned = this.amountTarget.value.trim().replace(/,/g, "").replace(/^\$/, "").trim()
    if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return

    this.previewTarget.textContent = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(cleaned))
  }
}
